<template>
    <div>
        <Upload class="hraf-upload" ref="upload" :multiple="true" :action="api" :on-success="handleSuccess"
                :accept="accept"
                :data="{type: target, docCode: docCode}" :show-upload-list="false">
            <Button type="default" icon="ios-cloud-upload-outline">{{ title || '上传' }}</Button>
            <!--<Button v-if="downloadPath" type="default" icon="ios-cloud-download-outline" @click="download"-->
            <!--style="margin-left: 10px">下载-->
            <!--</Button>-->

        </Upload>
        <div v-for="dItem in defaultFileList" :key="dItem.url" style="padding: 10px 0;">
            <span :key="dItem.url" @click="download(dItem.url)">{{dItem.name}}</span>
            <Button style="margin-left: 10px" @click="download(dItem.url)" type="primary">下载</Button>
            <Button style="margin-left: 10px" @click="handleRemoveFile(dItem)">删除</Button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'uploader',
        props: ['target', 'title', 'docCode', 'accept', 'defaultFileList', 'downloadPath'],
        data() {
            return {
                //api: '//jsonplaceholder.typicode.com/posts/',
                api: '/api/File/upload',
                path: this.downloadPath || '', // 预览·
            }
        },
        methods: {
            handleSuccess(res, file) {
                console.log(res)
                if (!res.reFlag) {
                    this.$Message.error(res.message)
                    return false
                }
                this.$Message.info('上传成功')
                if (!this.defaultFileList) {
                    this.defaultFileList = [];
                }
                this.defaultFileList.push({url: res.data.picName, name: res.data.picName})
                this.$emit("update:defaultFileList", this.defaultFileList)
                this.$emit("uploadSuccess", res, this.target)
                this.$emit('change', res.data.picName, this.target) // 上传回调
            },
            download(path) {
                window.location.href = window.location.origin + `/api/File/download?fileName=${path}`
            },
            handleRemoveFile(dItem) {
                let number = this.defaultFileList.indexOf(dItem);
                this.defaultFileList.splice(number,1)
                this.$emit("update:defaultFileList", this.defaultFileList)
                this.$emit("on-remove-file",this.defaultFileList,dItem,this.target);
            }
        }
    }
</script>
<style>
    .hraf-upload .ivu-upload-list li {
    }
</style>
